import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const UmbrellaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 1C7.86256 1 7.72512 1.44561 7.62922 2.01019C5.04762 2.14941 1.3385 3.72742 1.02174 7.4768C1.0063 7.65958 1.23374 7.75446 1.37347 7.63561C1.91041 7.17891 2.66534 6.8 3.69231 6.8C4.476 6.8 5.10128 7.24131 5.47207 7.58868C5.67177 7.77577 6.02054 7.77577 6.22024 7.58868C6.59103 7.24131 7.2163 6.8 8 6.8C8.88278 6.8 9.39704 7.17331 9.74875 7.53741C9.94979 7.74552 10.3366 7.7278 10.56 7.54393C11.005 7.17778 11.7157 6.8 12.3077 6.8C12.9721 6.8 13.8927 7.15683 14.5261 7.59531C14.6862 7.70608 14.9441 7.57138 14.9092 7.37991C14.1648 3.29767 10.9018 2.11049 8.37033 2.00754C8.27445 1.44422 8.13723 1 8 1Z"
		/>
		<path
			fill="currentColor"
			d="M8.75 8.65358C8.75 8.23937 8.41421 8 8 8C7.58579 8 7.25 8.23937 7.25 8.65358V12.75C7.25 13.1642 6.91421 13.5 6.5 13.5C6.08579 13.5 5.75 13.1642 5.75 12.75V12C5.75 11.5858 5.41421 11.5 5 11.5C4.58579 11.5 4.25 11.5858 4.25 12V12.75C4.25 13.9926 5.25736 15 6.5 15C7.74264 15 8.75 13.9926 8.75 12.75V8.65358Z"
		/>
	</svg>
))
